// src/components/Breadcrumbs.tsx
import { ChevronRight } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { FC } from 'react';

type BreadcrumbItem = {
  label: string;
  to?: string; // if present, it's clickable
  onClick?: () => void; // optional handler
};

type BreadcrumbsProps = {
  items: BreadcrumbItem[];
};

const Breadcrumbs: FC<BreadcrumbsProps> = ({ items }) => {
  const navigate = useNavigate();

  return (
    <div className="d-flex align-items-center gap-2 text-dark fw-semibold mb-3">
      {/* Home Icon */}
      <svg
        onClick={() => navigate('/dashboard')}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ cursor: 'pointer' }}
      >
        <path
          d="M1.5 7.99989L7.46967 2.03022C7.76256 1.73732 8.23744 1.73732 8.53033 2.03022L14.5 7.99989M3 6.49989V13.2499C3 13.6641 3.33579 13.9999 3.75 13.9999H6.5V10.7499C6.5 10.3357 6.83579 9.99989 7.25 9.99989H8.75C9.16421 9.99989 9.5 10.3357 9.5 10.7499V13.9999H12.25C12.6642 13.9999 13 13.6641 13 13.2499V6.49989M5.5 13.9999H11"
          stroke="#4B5563"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      {items.map((item, index) => (
        <div key={index} className="d-flex align-items-center gap-2">
          <ChevronRight fontSize="small" sx={{ color: '#C0C6CE' }} />
          {item.to ? (
            <span
              onClick={() => navigate(item.to!)}
              style={{ cursor: 'pointer', color: '#043C5B', fontWeight: 600 }}
            >
              {item.label}
            </span>
          ) : item.onClick ? (
            <button
              onClick={item.onClick}
              style={{
                all: 'unset',
                cursor: 'pointer',
                color: '#043C5B',
                fontWeight: 600,
              }}
            >
              {item.label}
            </button>
          ) : (
            <span>{item.label}</span>
          )}
        </div>
      ))}
    </div>
  );
};

export default Breadcrumbs;
